import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import { showResultPopup } from "$ACTIONS/helper";
import { promotionActions } from "$STORE/promotionSlice";
import DetailModal from "@/Promotion/Detail";
import MyPromotionList from "@/MyPromotionTabs/List";
import StartPromotionModal from "@/MyPromotionTabs/NotStarted/StartPromotionModal";
import { PromotionDetail, GetAssignedClaimsList } from "$ACTIONS/cmsApi";

const NotStarted = () => {
    const [filteredData, setFilteredData] = useState([]);
    const [lastUpdated, setLastUpdated] = useState("");
    const [modalVisible, setModalVisible] = useState(false);
    const [startModalVisible, setStartModalVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [detailContent, setDetailContent] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isDetailLoading, setIsDetailLoading] = useState(false);
    const dispatch = useDispatch();

    const fetchData = async () => {
        setLoading(true);
        try {
            const res = await GetAssignedClaimsList();
            if (res?.length > 0) {
                // 获取当前时间并转换为 GMT+8
                const now = moment().utcOffset(8);
                const validData = res.filter((item) =>
                    moment(item.claimEndDateUtc).utcOffset(8).isAfter(now)
                ); // 過濾過期數據

                if (validData.length > 0) {
                    // 設置最新更新時間
                    setLastUpdated(
                        moment(validData[0].updatedDateUtc)
                            .utcOffset(8)
                            .format("DD/MM/YYYY HH:mm [GMT+8]")
                    );
                } else {
                    setLastUpdated(""); // 如果没有有效数据，清空 lastUpdated
                }

                setFilteredData(validData);
            } else {
                console.error("API Response Error:", res);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setFilteredData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const goToInProgress = () => {
        dispatch(promotionActions.changeTab("2"));
        dispatch(promotionActions.setMyPromotionSubtab("inProgress"));
    };

    const handleCardAction = async (item, actionType) => {
        try {
            if (actionType === "start") {
                Pushgtagdata(
                    "Bonus",
                    "Start Promotion",
                    "Bonus_C_StartPromotion",
                    false,
                    [
                        {
                            customVariableKey:
                                "Bonus_C_StartPromotion_PromoName_PrmoID",
                            customVariableValue: `${item?.promoData?.promoTitle || ""}_${item?.promoData?.promoId || ""}`,
                        },
                    ]
                );

                // 获取当前时间并转换为 GMT+8
                const now = moment().utcOffset(8);
                // 转换 claimEndDateUtc 为 GMT+8
                const claimEndTime = moment(item?.claimEndDateUtc).utcOffset(8);

                if (now.isAfter(claimEndTime)) {
                    // Expired
                    showResultPopup({
                        type: "info",
                        title: "ขอรับโปรโมชั่นไม่สำเร็จ",
                        content: "โปรโมชั่นหมดอายุแล้ว โปรดเลือกโปรโมชั่นอื่น",
                        okText: "ตกลง",
                        onOk: () => console.log("彈窗已關閉"),
                    });
                } else {
                    setSelectedItem(item);
                    setStartModalVisible(true);
                }
            } else if (actionType === "detail") {
                setIsDetailLoading(true);
                setSelectedItem(item);
                setModalVisible(true);
                Pushgtagdata("Bonus", "View Bonus Detail", "Bonus_C_Detail");

                const param = { campaignId: item?.campaignId };

                try {
                    const res = await PromotionDetail(param);
                    if (res) {
                        setDetailContent(res);
                    }
                } catch (error) {
                    console.error("Error fetching promotion details:", error);
                } finally {
                    setIsDetailLoading(false);
                }
            }
        } catch (error) {
            console.error("Error in handleCardAction:", error);
        }
    };

    const handleModalClose = () => {
        setModalVisible(false);
        setSelectedItem(null);
    };

    const handleStartModalClose = () => {
        setStartModalVisible(false);
        setSelectedItem(null);
    };

    const renderImportantNote = () => (
        <div className="important-note">
            <p className="important-note-title">การแจ้งเตือนที่สำคัญ</p>
            <p className="important-note-content">
                โปรดคลิก "ขอรับตอนนี้" เพื่อเข้าร่วมโปรโมชั่นก่อนจะ
                "สิ้นสุดโปรโมชั่น" มิฉะนั้น
                โปรโมชั่นจะไม่สามารถเข้าร่วมได้และจะหายไปจากหน้าโปรโมชั่น
            </p>
        </div>
    );

    return (
        <>
            <MyPromotionList
                promotions={filteredData}
                loading={loading}
                type="notStarted"
                renderImportantNote={renderImportantNote}
                onCardActionClick={handleCardAction}
                lastUpdatedTime={lastUpdated}
                showTabs={false}
                showDatePicker={false}
            />
            {/* 詳情彈窗 */}
            {modalVisible && (
                <DetailModal
                    promotionInfo={detailContent}
                    isLoading={isDetailLoading}
                    isDetailVisible={modalVisible}
                    closeDetail={handleModalClose}
                    from="MyPromotion"
                />
            )}
            {/* 開始優惠彈窗 */}
            {startModalVisible && (
                <StartPromotionModal
                    visible={startModalVisible}
                    onClose={handleStartModalClose}
                    selectedItem={selectedItem}
                    onSuccess={goToInProgress}
                />
            )}
        </>
    );
};

export default NotStarted;
